import { render, staticRenderFns } from "./IconSvgBookmarkEmpty.vue?vue&type=template&id=1c9facc0&scoped=true&"
import script from "./IconSvgBookmarkEmpty.vue?vue&type=script&lang=js&"
export * from "./IconSvgBookmarkEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9facc0",
  null
  
)

export default component.exports